import { Controller } from "@hotwired/stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import ptBrLocale from "@fullcalendar/core/locales/pt-br"

export default class extends Controller {
  static values = { availableDays: Array, specialistId: Number }

  connect() {
    const calendarEl = this.element
    const availableDays = this.availableDaysValue
    const specialistId = this.specialistIdValue

    const calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridMonth",
      locale: ptBrLocale,
      fixedWeekCount: false,
      showNonCurrentDates: false,
      headerToolbar: {
        left: "prev,next",
        center: "title",
        right: ""
      },
      titleFormat: { year: 'numeric', month: 'long' },
      selectable: true,
      viewDidMount: function(arg) {
        const titleEl = document.querySelector('.fc-toolbar-title')
        if (titleEl) {
          titleEl.innerText = titleEl.innerText.charAt(0).toUpperCase() + titleEl.innerText.slice(1)
        }
      },
      dayCellDidMount: function(info) {        
        const today = new Date()
        const cellDate = info.date

        if (cellDate < today || cellDate < new Date().setHours(48)) {
          info.el.classList.add("pointer")
        } else {
          const weekday = cellDate.toLocaleString("pt-BR", { weekday: "long" })
          if (availableDays.includes(weekday)) {
            info.el.classList.add("fc-green")
          } else {
            info.el.classList.add("pointer")
          }
        }
      },
      dateClick: function(info) {
        const today = new Date()
        if (info.date < today) return

        const availableDates = document.getElementById("available-dates")
        availableDates.innerHTML = ""

        info.dayEl.classList.remove("fc-green")
        info.dayEl.classList.add("fc-selected")
        
        fetch(`/pages/profiles/${specialistId}/dates/${info.dateStr}`, {
          headers: { Accept: "text/vnd.turbo-stream.html" }
        })
          .then(response => response.text())
          .then(html => Turbo.renderStreamMessage(html))
      }
    })

    calendar.render()
  }
}
